export const c = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Structural deep clone (preserves Date, plain objects and arrays).
 * Moved out of the 2900-line test `mocks.ts` so production code no longer
 * drags the whole mock module into the app bundle.
 */
export const deepCopy = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key]);
      return newObj;
    }, {});
  }
};

export const deepCopyJSON = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};
